module.exports = __webpack_public_path__ + "img/symbol_11.1303abeb.png";